var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastenalProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b8ab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#1a64b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99471,
    stopColor: "#1a389c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.25476 72.83081 56.0603 72.83081 59.0484 62.4201 68.83362 62.37299 69.1665 61.1795 69.11005 61.27655 70.20178 57.46826 60.46887 57.46826 61.72369 53.10114 72.29993 53.10114 73.72034 48.14929 55.33588 48.14929 48.25476 72.83081"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.45447,47.9906l16.11835-9.30554c.78961-.45587.78961-1.59552,0-2.05139l-5.6098-3.23883-18.48676,10.67346,6.79382,3.9223c.36646.21155.81793.21155,1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.27032,27.32788l-16.11816,9.30585c-.78961.45587-.78961,1.59552,0,2.05139l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21161-.81793-.21161-1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.85522,62.96869l16.18445,9.34412c.76733.44305,1.72656-.11072,1.72656-.99677v-18.68817c0-.41125-.21942-.7912-.5755-.99683l-6.87177-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.76733-.44305-1.72656.11072-1.72656.99683v18.68835c0,.41119.21942.7912.57556.99677Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastenalProductsScraper);
export default __webpack_public_path__ + "static/media/fastenal-products-scraper.c368440f0a8a3e2c9749bd380d2acaca.svg";
export { ForwardRef as ReactComponent };